import React, {useEffect } from "react";
import { useDispatch} from 'react-redux'
import {
  setBreadcrumb,
  setBreadcrumbSearch
} from '../_redux/_actions/breadcrumbAction'

export default function BreadcrumbDispatch() {
  const dispatch = useDispatch()

  useEffect (()=> {
    var pathArray = window.location.pathname.split("/") ;
    if(window.location.search){
      pathArray[pathArray.length-1]= pathArray[pathArray.length-1]
    }
    dispatch(setBreadcrumb(pathArray))
    if(window.location.search){
      dispatch(setBreadcrumbSearch(window.location.search.split('&')))
    }
  })

  return (
    null
  );
}
